import React from 'react'
import { buildReverseGeocodeId } from './api/google-integration'
import InfoWindowMarker from './components/InfoWindowMarker'
import InfowindowVehicle from './components/InfowindowVehicle'
import moment from 'moment'
import styled from 'styled-components'
import { getCarStatusStyle } from './utils'
import i18n from 'live/services/i18n'
import { ICON_STOP } from './components/InfoWindowMarker/index'

export const createVehicleInfoWindow = (hardware, vehicle, showTripsBtn?, marker?) => {
    if (!hardware || !vehicle) return undefined

    const { lat, lng } = hardware
    const content = <InfowindowVehicle showTripsBtn={showTripsBtn} hardware={hardware} vehicle={vehicle} />

    const popup = {
        marker,
        content,
        vehicle,
        hardware,
        latLng: { lat, lng },
        avarageSpeed: undefined,
        totalDistance: undefined
    }

    return popup
}

export const createPopupHoverTrip = (event, { timestamp, speed, status }) => {
    const statusAux = speed == 0 ? 'slow running' : status
    const statusTxt = speed == 0 ? i18n('slow running') : i18n(status)
    const style = getCarStatusStyle(statusAux)
    const liData = [
        { icon: 'fal fa-clock', text: `${moment(timestamp).format('HH:mm:ss')}` },
        { icon: 'far fa-tachometer-alt-average', text: `${speed} Km/h` },
        { icon: 'fas fa-circle', text: statusTxt, style }
    ]

    const content = (
        <InfoWindowTrip>
            <ul>
                {liData.map(({ icon, text, style }, index) => {
                    return (
                        <li key={index}>
                            <span className="spacing-icon">
                                <i className={icon} style={style}></i>
                            </span>

                            <span>
                                <b>{text}</b>
                            </span>
                        </li>
                    )
                })}
            </ul>
        </InfoWindowTrip>
    )

    const popup = {
        content,
        latLng: { lat: event.latLng.lat(), lng: event.latLng.lng() }
    }

    return popup
}

export const createMarkerInfoWindow = (prop, type, reverseGeocoding, marker?): any => {
    const { lat, lng, timestamp, avarageSpeed, travelledDistance } = prop
    let title, titleTime
    const key = buildReverseGeocodeId(lat, lng)
    const address = reverseGeocoding[key]?.address
    const START = 1
    const END = 2
    const STOP = 3

    if (type === START) {
        title = 'Trip Start'
        titleTime = 'Start Time'
    } else if (type === END) {
        title = 'Trip End'
        titleTime = 'End Time'
    } else if (type === STOP) {
        title = 'Trip Stop'
    }

    const content = (
        <InfoWindowMarker
            title={title}
            markerColor="blue-500"
            address={address || 'N/D'}
            iconType={type}
            time={
                [START, END].includes(type) && {
                    icon: 'far fa-stopwatch',
                    title: titleTime,
                    value: `${moment(timestamp).format('DD/MM/YYYY')} ${moment(timestamp).format('HH:mm:ss')}`
                }
            }
            distance={
                type === END && {
                    icon: 'far fa-road',
                    title: 'Travel Distance',
                    value: `${travelledDistance}`
                }
            }
            speed={
                type === END && {
                    icon: 'far fa-road',
                    title: 'Average Speed',
                    value: avarageSpeed
                }
            }
        />
    )

    const popup = {
        marker,
        content,
        latLng: { lat, lng }
    }

    return popup
}

const InfoWindowTrip = styled.div`
    max-width: 250px;

    ul {
        list-style: none;

        li {
            display: flex;
            margin-bottom: 8px;
        }

        .spacing-icon {
            margin-right: 10px;
        }
    }

    button {
        color: #37a3ef;
        border: 1px solid #37a3ef;
        background: #fff;
        padding: 8px 22px;
        border-radius: 3px;
        font-weight: 600;
        font-size: 13px;

        span {
            margin-left: 15px;
        }
    }
`
